<template>
  <vs-navbar
    v-model="activeLink"
    color="primary"
    text-color="rgba(255,255,255,.6)"
    active-text-color="rgba(255,255,255,1)"
    class="pm-navbar"
  >
    <div slot="title" class="pm-navbar-title">
      <vs-navbar-title>
        <vs-row>
          <vs-col vs-type="flex" vs-align="center" vs-w="12">
            <vs-icon icon="call_split" />
            Enter Gateway
          </vs-col>
        </vs-row>
      </vs-navbar-title>
    </div>

    <vs-navbar-item index="/">
      <router-link to="/">
        Дайджест
      </router-link>
    </vs-navbar-item>

    <vs-navbar-item index="/templates">
      <router-link to="/templates">
        Шаблоны
      </router-link>
    </vs-navbar-item>

    <vs-navbar-item index="/sending">
      <router-link to="/sending">Рассылки</router-link>
    </vs-navbar-item>

    <vs-navbar-item index="/sms-list">
      <router-link to="/sms-list">Список SMS</router-link>
    </vs-navbar-item>
  </vs-navbar>
</template>

<script>
export default {
  name: 'PmNavbar',
  computed: {
    activeLink: {
      get() {
        return this.active || this.$route.path
      },
      set(route) {
        this.active = route
      }
    }
  },
  data: () => ({
    active: ''
  })
}
</script>

<style lang="stylus">
.pm-navbar
  color #fff
  position fixed

.pm-navbar-title
  i
    margin-right 7px
</style>
